  // GSAPとScrollTriggerのライブラリを動的に読み込み
  const loadGSAP = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js';
      script.onload = resolve;
      document.head.appendChild(script);
    });
  };

  const loadScrollTrigger = () => {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js';
      script.onload = resolve;
      document.head.appendChild(script);
    });
  };

  // ライブラリを順番に読み込む
  (async function() {
    await loadGSAP();
    await loadScrollTrigger();
    // ライブラリ読み込み完了後にイベントを発火
    document.dispatchEvent(new Event('gsapLoaded'));
  })();

// スクロールトリガーの設定値を変数として定義
const scrollTriggerConfig = {
  // ウィンドウ幅に応じて設定を返す関数
  getConfig: () => {
    const isMobile = window.innerWidth < 768; // 768px以下をSPとする
    return {
      start: isMobile ? "left 30%" : "left 80%",
      end: isMobile ? "right right" : "right right"
    };
  }
};

  window.addEventListener("load", () => {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      gsap.registerPlugin(ScrollTrigger);
      // スマホでのタッチスクロールも確実に検知するように設定
      ScrollTrigger.config({
        ignoreMobileResize: true
      });

      // ページ内リンクのスムーズスクロール
      document.querySelectorAll('.picasso-03-item, .picasso-13-item').forEach(link => {
        link.addEventListener('click', (e) => {
          // 外部リンクの場合は通常のリンク遷移を行う
          if (link.getAttribute('href').startsWith('http')) {
            return;
          }

          e.preventDefault();
          const targetId = link.getAttribute('href').split('#')[1];
          const targetElement = document.getElementById(targetId);

          // コンテナのスクロール位置を計算
          const container = document.querySelector('.picasso-container');
          const targetPosition = targetElement.offsetLeft;

          // GSAPでスムーズスクロール
          gsap.to(container, {
            scrollLeft: targetPosition,
            duration: 1,
            ease: "power2.inOut"
          });
        });
      });

      ScrollTrigger.create({
        trigger: ".picasso-01",
        scroller: ".picasso-container",
        horizontal: true,
        start: scrollTriggerConfig.getConfig().start,
        end: scrollTriggerConfig.getConfig().end,
        immediateRender: true,
        onEnter: () => {
          gsap.to(".picasso-01-scroll", {
            x: 90,
            duration: 2,
            ease: "power2.inOut",
            yoyo: true,
            repeat: -1
          });
        }
      });
      ScrollTrigger.create({
        trigger: ".picasso-02",
        scroller: ".picasso-container",
        horizontal: true,
        start: scrollTriggerConfig.getConfig().start,
        end: scrollTriggerConfig.getConfig().end,
        immediateRender: true,
        onEnter: () => {
          gsap.to(".picasso-02-title .name", {
            y: 0,
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut"
          });
          gsap.to(".picasso-02-title .shadow", {
            opacity: 0.25,
            duration: 2.5,
            ease: "power2.inOut"
          });
          gsap.to(".picasso-02 p", {
            opacity: 1,
            duration: 1.5,
            ease: "power2.inOut",
            stagger: 0.4
          });
          // 疑似要素のアニメーション
          gsap.to(".picasso-02 .accent", {
            "--accent-scale": 1,
            duration: 2,
            ease: "power2.inOut"
          });
        }
      });
      ScrollTrigger.create({
        trigger: ".picasso-03",
        scroller: ".picasso-container",
        horizontal: true,
        start: scrollTriggerConfig.getConfig().start,
        end: scrollTriggerConfig.getConfig().end,
        immediateRender: true,
        once: true,
        onEnter: () => {
          gsap.to([".picasso-03 h2", ".picasso-03 .sub-title"], {
            y: 0,
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut"
          });
          gsap.to(".picasso-03-item", {
            x: 0,
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut",
            stagger: 0.1
          });
        }
      });
      ScrollTrigger.create({
        trigger: ".picasso-04",
        scroller: ".picasso-container",
        horizontal: true,
        start: scrollTriggerConfig.getConfig().start,
        end: scrollTriggerConfig.getConfig().end,
        immediateRender: true,
        once: true,
        onEnter: () => {
          gsap.to([".picasso-04 .picasso-product-text-01", ".picasso-04 .picasso-product-text-02"], {
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut"
          });
          // GSAPでクラスを追加
          gsap.to(".picasso-04 figure", {
            className: "scroll-active",
            duration: 0.01
          });
          // GSAPでクラスを削除（1秒後）
          gsap.to(".picasso-04 figure", {
            className: "remove-scroll-active",
            delay: 0.6,
            duration: 0.01
          });
        }
      });
      ScrollTrigger.create({
        trigger: ".picasso-05",
        scroller: ".picasso-container",
        horizontal: true,
        start: scrollTriggerConfig.getConfig().start,
        end: scrollTriggerConfig.getConfig().end,
        immediateRender: true,
        onEnter: () => {
          gsap.to([".picasso-05 h3", ".picasso-05 p"], {
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut"
          });
          gsap.to(".picasso-05 img", {
            autoAlpha: 1,
            duration: 1.5,
            ease: "power2.inOut"
          });
          gsap.to(".picasso-05 a", {
            autoAlpha: 1,
            duration: 2,
            ease: "power2.inOut"
          });
        }
      });
      ScrollTrigger.create({
        trigger: ".picasso-06",
        scroller: ".picasso-container",
        horizontal: true,
        start: scrollTriggerConfig.getConfig().start,
        end: scrollTriggerConfig.getConfig().end,
        immediateRender: true,
        once: true,
        onEnter: () => {
          gsap.to([".picasso-06 .picasso-product-text-01", ".picasso-06 .picasso-product-text-02"], {
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut"
          });
          // GSAPでクラスを追加
          gsap.to(".picasso-06 figure", {
            className: "scroll-active",
            duration: 0.01
          });
          // GSAPでクラスを削除（1秒後）
          gsap.to(".picasso-06 figure", {
            className: "remove-scroll-active",
            delay: 0.6,
            duration: 0.01
          });
        }
      });
      ScrollTrigger.create({
        trigger: ".picasso-07",
        scroller: ".picasso-container",
        horizontal: true,
        start: scrollTriggerConfig.getConfig().start,
        end: scrollTriggerConfig.getConfig().end,
        onEnter: () => {
          gsap.to([".picasso-07 h3", ".picasso-07 p"], {
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut"
          });
          gsap.to(".picasso-07 img", {
            autoAlpha: 1,
            duration: 1.5,
            ease: "power2.inOut"
          });
          gsap.to(".picasso-07 a", {
            autoAlpha: 1,
            duration: 2,
            ease: "power2.inOut"
          });
        }
      });
      ScrollTrigger.create({
        trigger: ".picasso-08",
        scroller: ".picasso-container",
        horizontal: true,
        start: scrollTriggerConfig.getConfig().start,
        end: scrollTriggerConfig.getConfig().end,
        once: true,
        onEnter: () => {
          gsap.to([".picasso-08 .picasso-product-text-01", ".picasso-08 .picasso-product-text-02"], {
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut"
          });
          // GSAPでクラスを追加
          gsap.to(".picasso-08 figure", {
            className: "scroll-active",
            duration: 0.01
          });
          // GSAPでクラスを削除（1秒後）
          gsap.to(".picasso-08 figure", {
            className: "remove-scroll-active",
            delay: 0.6,
            duration: 0.01
          });
        }
      });
      ScrollTrigger.create({
        trigger: ".picasso-09",
        scroller: ".picasso-container",
        horizontal: true,
        start: scrollTriggerConfig.getConfig().start,
        end: scrollTriggerConfig.getConfig().end,
        onEnter: () => {
          gsap.to([".picasso-09 h3", ".picasso-09 p"], {
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut"
          });
          gsap.to(".picasso-09 img", {
            autoAlpha: 1,
            duration: 1.5,
            ease: "power2.inOut"
          });
          gsap.to(".picasso-09 a", {
            autoAlpha: 1,
            duration: 2,
            ease: "power2.inOut"
          });
        }
      });
      ScrollTrigger.create({
        trigger: ".picasso-10",
        scroller: ".picasso-container",
        horizontal: true,
        start: scrollTriggerConfig.getConfig().start,
        end: scrollTriggerConfig.getConfig().end,
        once: true,
        onEnter: () => {
          gsap.to([".picasso-10 .picasso-product-text-01", ".picasso-10 .picasso-product-text-02"], {
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut"
          });
          // GSAPでクラスを追加
          gsap.to(".picasso-10 figure", {
            className: "scroll-active",
            duration: 0.01
          });
          // GSAPでクラスを削除（1秒後）
          gsap.to(".picasso-10 figure", {
            className: "remove-scroll-active",
            delay: 0.6,
            duration: 0.01
          });
        }
      });
      ScrollTrigger.create({
        trigger: ".picasso-11",
        scroller: ".picasso-container",
        horizontal: true,
        start: scrollTriggerConfig.getConfig().start,
        end: scrollTriggerConfig.getConfig().end,
        onEnter: () => {
          gsap.to([".picasso-11 h3", ".picasso-11 p"], {
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut"
          });
          gsap.to(".picasso-11 img", {
            autoAlpha: 1,
            duration: 1.5,
            ease: "power2.inOut"
          });
          gsap.to(".picasso-11 a", {
            autoAlpha: 1,
            duration: 2,
            ease: "power2.inOut"
          });
        }
      });
      ScrollTrigger.create({
        trigger: ".picasso-12",
        scroller: ".picasso-container",
        horizontal: true,
        start: scrollTriggerConfig.getConfig().start,
        end: scrollTriggerConfig.getConfig().end,
        onEnter: () => {
          gsap.to([".picasso-12 h2", ".picasso-12 .sub-title"], {
            y: 0,
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut"
          });
          gsap.to(".picasso-12-gallery figure", {
            autoAlpha: 1,
            duration: 2,
            ease: "power2.inOut"
          });
        }
      });
      ScrollTrigger.create({
        trigger: ".picasso-13",
        scroller: ".picasso-container",
        horizontal: true,
        start: "left 80%",
        end: "right right",
        immediateRender: true,
        once: true,
        onEnter: () => {
          gsap.to([".picasso-13 h2", ".picasso-13 .sub-title"], {
            y: 0,
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut"
          });
          gsap.to(".picasso-13-item", {
            x: 0,
            autoAlpha: 1,
            duration: 1,
            ease: "power2.inOut",
            stagger: 0.1
          });
        }
      });
    } else {
      console.error("GSAP または ScrollTrigger が読み込まれていません");
    }
  });
